var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.5@core-js/library/modules/_html.js
// module id = 288
// module chunks = 16